import { SitesStatsResult, StatsKey } from "./types";

export const ISSUE_TYPE_LABELS: { [key in StatsKey]: string } = {
    [StatsKey.AllSites]: "All Sites",
    [StatsKey.OnlineSites]: "Online Sites",
    [StatsKey.ActiveAlarm]: "Alarms",
    [StatsKey.SiteOffline]: "Sites Offline",
    [StatsKey.RoomBoxLeftOpen]: "Room Box Left Open",
    [StatsKey.RoomEntryUnauthorized]: "Room Entry Unauthorized",
    [StatsKey.RoomInUse]: "Room In Use",
    [StatsKey.RoomIdle]: "Room Idle",
}

export const INIT_SITE_STATS_RESULT: SitesStatsResult = {
    sitesOffline: [],
    sitesOnline: [],
    sitesWithAlarm: [],
    sitesWithRoomBoxLeftOpen: [],
    sitesWithRoomEntryUnauthorized: [],
    sitesWithRoomInUse: [],
    sitesWithRoomIdle: [],
    issueCount: 0,
}
